interface IServiceRequest<T = any> {
  payload: T;
}

abstract class ServiceRequestBase<T = any> implements IServiceRequest<T> {
  protected constructor(public payload: T) {
  }
}

export { IServiceRequest, ServiceRequestBase };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/service-request/request.ts